import { useState } from "react";
import Table from "../../components/table/table";
import { TbDotsVertical } from "react-icons/tb";
import { IoEyeOutline } from "react-icons/io5";
import EditIcon from "../../icons/editIcon";
import DeleteIcon from "../../icons/deleteIcon";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../components/dropDownMenu/dropdown-menu";
import Checkbox from "../../components/inputs/checkbox";
import { FaCircle } from "react-icons/fa";
import { FaCheckSquare } from "react-icons/fa";
import { LuClock12 } from "react-icons/lu";
import NotificationOutLinedIcon from "../../icons/notificationOutinedIcon";
import { useNavigate } from "react-router-dom";

const MembersTable = ({ t, setOpenDelete, setOpenRegistration, setOpenSend }) => {
  const [selectedIds, setSelectedIds] = useState([]);

  const handleCheck = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleCheckAll = () => {
    if (selectedIds.length === members.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(members.map((m) => m.id));
    }
  };
  const handleClick = (m, setState) => {
    setState(true);
  };
  const members = [
    {
      id: 1,
      name: "دورة كاراتيه",
      registration: "20 / 18",
      attendance: "15",
      type: "رياضي",
      status: "نشط",
      date: "12/06/2023",
    },
    {
      id: 2,
      name: "يوم السباحة العائلي",
      registration: "50 / 45",
      type: "رياضي",
      attendance: "15",
      status: "قادم",
      date: "12/06/2023",
    },
    {
      id: 3,
      name: "بطولة كرة القدم",
      registration: "24 / 24",
      type: "عائلي",
      attendance: "15",
      status: "مكتمل",
      date: "10/01/2022",
    },
    {
      id: 4,
      name: "دورة كاراتيه",
      registration: "24 / 24",
      type: "شبابي",
      attendance: "15",
      status: "مكتمل",
      date: "25/05/2024",
    },
    {
      id: 5,
      name: "دورة كاراتيه",
      registration: "24 / 24",
      type: "رياضي",
      attendance: "15",
      status: "مكتمل",
      date: "12/06/2023",
    },
    {
      id: 6,
      name: "دورة كاراتيه",
      registration: "24 / 24",
      type: "رياضي",
      attendance: "15",
      status: "مكتمل",
      date: "12/06/2023",
    },
    {
      id: 7,
      name: "دورة كاراتيه",
      registration: "24 / 24",
      type: "رياضي",
      attendance: "15",
      status: "مكتمل",
      date: "12/06/2023",
    },
    {
      id: 8,
      name: "دورة كاراتيه",
      registration: "24 / 24",
      type: "رياضي",
      attendance: "15",
      status: "مكتمل",
      date: "10/01/2022",
    },
    {
      id: 9,
      name: "دورة كاراتيه",
      registration: "24 / 24",
      type: "رياضي",
      attendance: "15",
      status: "مكتمل",
      date: "25/05/2024",
    },
  ];

  const tableHead = [
    {
      header: (
        <Checkbox
          checked={selectedIds.length === members.length}
          onChange={handleCheckAll}
          id={"members-all"}
        />
      ),
      accessorKey: "check",
    },
    {
      header: t("name"),
      accessorKey: "name",
    },
    {
      header: t("type"),
      accessorKey: "type",
    },
    {
      header: t("date"),
      accessorKey: "date",
    },
    {
      header: t("registration"),
      accessorKey: "registration",
    },
    {
      header: t("attendance1"),
      accessorKey: "attendance",
    },
    {
      header: t("status"),
      accessorKey: "status",
    },

    {
      header: t("actions"),
      accessorKey: "actions",
    },
  ];
  const navigate = useNavigate();
  const tableData = members.map((m, i) => {
    const check = (
      <Checkbox
        checked={selectedIds.includes(m.id)}
        onChange={() => handleCheck(m.id)}
        id={`member-${i}`}
      />
    );
    const statusIcon =
      m.status === "نشط" ? (
        <FaCheckSquare className="text-[#11A849]" />
      ) : m.status === "مكتمل" ? (
        <FaCircle className="text-white" />
      ) : (
        <FaCircle className="text-[#D1A855]" />
      );
    const status = (
      <span className="flex items-center justify-center gap-1 px-2 py-1 text-white rounded-lg">
        {statusIcon}
        {m.status}
      </span>
    );
    const actions = (
      <div className="relative mx-auto w-fit">
        <DropdownMenu>
          <DropdownMenuTrigger>
            <TbDotsVertical />
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem>
              <button
                onClick={() => navigate(`/activities/${m.id}`)}
                className="flex items-center justify-end w-full gap-2 px-4 py-2 text-white hover:bg-sideBar ltr:flex-row-reverse rtl:flex-row"
              >
                {t("showDetails")}
                <IoEyeOutline size={24} />
              </button>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <button
                onClick={() => navigate(`/activities/edit`)}
                className="flex items-center justify-end w-full gap-2 px-4 py-2 text-white hover:bg-sideBar ltr:flex-row-reverse rtl:flex-row"
              >
                {t("editActivity")}
                <EditIcon />
              </button>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <button
                onClick={() => handleClick(m, setOpenRegistration)}
                className="flex items-center justify-end w-full gap-2 px-4 py-2 text-white hover:bg-sideBar ltr:flex-row-reverse rtl:flex-row"
              >
                {t("manualMemberRegistration")}
                <LuClock12 size={24} />
              </button>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <button
                onClick={() => handleClick(m, setOpenSend)}
                className="flex items-center justify-end w-full gap-2 px-4 py-2 text-white hover:bg-sideBar ltr:flex-row-reverse rtl:flex-row"
              >
                {t("sendNotification")}
                <NotificationOutLinedIcon />
              </button>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <button
                onClick={() => handleClick(m, setOpenDelete)}
                className="flex items-center gap-2 justify-end w-full text-[#FF5151] px-4 py-2 text-right hover:bg-sideBar ltr:flex-row-reverse rtl:flex-row"
              >
                {t("deleteActivity")}
                <DeleteIcon />
              </button>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    );
    return {
      check,
      name: m.name,
      type: m.type,
      date: m.date,
      registration: m.registration,
      attendance: m.attendance,
      status,
      actions,
    };
  });
  return <Table TableData={tableData} TableHead={tableHead} />;
};

export default MembersTable;
